import { useOktaAuth } from '@okta/okta-react'
import { FC } from 'react'
import { NavDropdown } from 'react-bootstrap'
import { DropdownItemProps } from 'react-bootstrap/esm/DropdownItem'
import { Link } from 'react-router-dom'
import { RoleNames } from 'shared/models/Enum'
import { hasRole } from 'shared/utils/roleHelpers'

const ProtectedNavDropdownItem: FC<
  { requiredRole: RoleNames; to: string } & DropdownItemProps
> = ({ requiredRole, to, ...rest }) => {
  const { authState } = useOktaAuth()

  if (!hasRole(authState, requiredRole)) {
    return null
  }

  return <NavDropdown.Item as={Link} to={to} {...rest} />
}

export default ProtectedNavDropdownItem
